import { CustomerFormOptions } from '../types/CustomerTypes';
import {
  useGetAccountTypesQuery,
  useGetCustomerTypesQuery,
  useGetPricingSchemesQuery,
  useGetSalesAgentsQuery,
  useGetSalesRegionsQuery,
  useGetTermsQuery
} from '@/common/infrastructure/gql/generated/schema';

export const useGetCustomerFormOptions = (skip: boolean) => {
  const {
    data: accountTypesData,
    loading: accountTypesLoading,
    error: accountTypesError
  } = useGetAccountTypesQuery({
    skip,
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first'
  });
  const {
    data: customerTypesData,
    loading: customerTypesLoading,
    error: customerTypesError
  } = useGetCustomerTypesQuery({
    skip,
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first'
  });
  const {
    data: pricingSchemesData,
    loading: pricingSchemesLoading,
    error: pricingSchemesError
  } = useGetPricingSchemesQuery({
    skip,
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first'
  });
  const {
    data: salesAgentsData,
    loading: salesAgentsLoading,
    error: salesAgentsError
  } = useGetSalesAgentsQuery({
    skip,
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first'
  });
  const {
    data: salesRegionsData,
    loading: salesRegionsLoading,
    error: salesRegionsError
  } = useGetSalesRegionsQuery({
    skip,
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first'
  });
  const {
    data: termsData,
    loading: termsLoading,
    error: termsError
  } = useGetTermsQuery({
    skip,
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first'
  });
  const formOptions = {
    availableCustomerTypes: customerTypesData?.customerTypes?.items ?? [],
    availableSalesAgents: salesAgentsData?.salesAgents?.items ?? [],
    availableTerms: termsData?.terms?.items ?? [],
    availablePricingSchemes: pricingSchemesData?.pricingSchemes?.items ?? [],
    availableSalesRegions: salesRegionsData?.salesRegions?.items ?? [],
    availableAccountTypes: accountTypesData?.accountTypes?.items ?? []
  } as CustomerFormOptions;

  return {
    formOptions,
    loading:
      accountTypesLoading || customerTypesLoading || pricingSchemesLoading || salesAgentsLoading || salesRegionsLoading || termsLoading,
    error: accountTypesError || customerTypesError || pricingSchemesError || salesAgentsError || salesRegionsError || termsError,
    availableCustomerTypes: formOptions?.availableCustomerTypes ?? [],
    availableSalesAgents: formOptions?.availableSalesAgents ?? [],
    availableTerms: formOptions?.availableTerms ?? [],
    availablePricingSchemes: formOptions?.availablePricingSchemes ?? [],
    availableSalesRegions: formOptions?.availableSalesRegions ?? [],
    availableAccountTypes: formOptions?.availableAccountTypes ?? []
  };
};
